var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-layout-text-container"},_vm._l((_vm.sections),function(section,index){return _c('div',{key:index},[_c('h1',[_vm._v(_vm._s(section.title))]),_vm._v(" "),_vm._l((section.paragraphs),function(paragraph,index){return _c('p',{key:index},[_vm._v("\n      "+_vm._s(paragraph.text)+"\n    ")])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }